import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component for adding JSON-LD structured data to improve SEO
 * This helps search engines understand the context of the website better
 */
const SchemaMarkup = ({ 
  type = 'LocalBusiness',
  data = {}
}) => {
  // Default base data for all schema types
  const baseData = {
    '@context': 'https://schema.org',
    '@type': type,
    name: 'Cosmik Drones',
    description: 'Professional drone services in Lehigh Valley, PA offering aerial photography, FPV drone filming, real estate, and event coverage throughout Pennsylvania and the East Coast.',
    url: 'https://cosmikdrones.com',
    telephone: '+1-610-509-0867',
    email: 'Josh@Cosmikdrones.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Lehigh Valley',
      addressRegion: 'PA',
      postalCode: '18018',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '40.6084',
      longitude: '-75.4907'
    },
    image: 'https://cosmikdrones.com/Cosmik Logo/Kolonia_Logo.png',
    sameAs: [
      'https://instagram.com/josh.kolonia',
      'https://youtube.com/cosmikdrones',
      'https://facebook.com/cosmikdrones'
    ]
  };

  // Merge the base data with the provided data
  const schemaData = { ...baseData, ...data };

  // Convert to JSON string for the script
  const jsonLd = JSON.stringify(schemaData);

  return (
    <Helmet>
      <script type="application/ld+json">{jsonLd}</script>
    </Helmet>
  );
};

export default SchemaMarkup; 